import Gobalstore from "../index";
export const actions = {
  getDepartment: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/admin/guarded/management/department/`,
      })
        .then(function (response) {
          localStore.commit("setDepartment", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  createDepartment: function (localStore, payload) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "POST",
        url: `/admin/guarded/management/department/`,
        headers: payload.headers,
        data: payload.data,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  updateDepartment: function (localStore, body) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "PUT",
        url: `/admin/guarded/management/department/`,
        data: body,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  deleteDepartment: function (localStore, dep_id) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "DELETE",
        url: `/admin/guarded/management/department/${dep_id}`,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },
};
